import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { CreatePipelineInput, Pipeline, UpdatePipelineInput } from '@neuroedge/shared';
import { apiClient, ApiClientError } from './client';

const KEY = ['pipelines'] as const;

export async function listPipelines(): Promise<Pipeline[]> {
  const res = await apiClient.getCollection<Pipeline>('/pipelines', { query: { pageSize: 1000 } });
  return res.data;
}
export const getPipeline = (id: string) => apiClient.get<Pipeline>(`/pipelines/${id}`);
export const createPipeline = (input: CreatePipelineInput) =>
  apiClient.post<Pipeline>('/pipelines', input);
export const updatePipeline = (id: string, patch: UpdatePipelineInput) =>
  apiClient.patch<Pipeline>(`/pipelines/${id}`, patch);

export function usePipelines() {
  return useQuery<Pipeline[], ApiClientError>({
    queryKey: [...KEY, 'list'],
    queryFn: listPipelines,
  });
}

export function usePipeline(id: string | undefined) {
  return useQuery<Pipeline, ApiClientError>({
    queryKey: [...KEY, 'detail', id],
    queryFn: () => getPipeline(id!),
    enabled: Boolean(id),
  });
}

export function useCreatePipeline() {
  const qc = useQueryClient();
  return useMutation<Pipeline, ApiClientError, CreatePipelineInput>({
    mutationFn: createPipeline,
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function useUpdatePipeline(id: string) {
  const qc = useQueryClient();
  return useMutation<Pipeline, ApiClientError, UpdatePipelineInput>({
    mutationFn: (patch) => updatePipeline(id, patch),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}
